import { Box, Flex, SimpleGrid, Skeleton } from '@mantine/core';

function QuestionSkeleton() {
  return (
    <Box mb={30}>
      <Skeleton height={18} width="60%" mb="sm" />
      <SimpleGrid cols={2} spacing={0} sx={{ border: '1px solid #e2e2e2' }}>
        <Box p="sm" sx={{ borderRight: '1px solid #e2e2e2' }}>
          <Skeleton height={14} width="40%" />
        </Box>
        <Box p="sm">
          <Skeleton height={90} mb="sm" />
          <Skeleton height={14} width="35%" mb={6} />
          <Skeleton height={90} />
        </Box>
      </SimpleGrid>
    </Box>
  );
}

export function AssessmentSkeleton() {
  return (
    <Box w="100%" aria-busy="true" aria-label="Loading assessment">
      <QuestionSkeleton />
      <QuestionSkeleton />
      <Skeleton height={14} width={160} mb={6} />
      <Skeleton height={90} mb={50} />
      <SimpleGrid cols={2}>
        <Flex direction="column" align="center" gap="sm">
          <Skeleton height={14} width={120} />
          <Skeleton height={120} width={300} />
        </Flex>
        <Flex direction="column" align="center" gap="sm">
          <Skeleton height={14} width={120} />
          <Skeleton height={120} width={300} />
        </Flex>
      </SimpleGrid>
      <Flex justify="flex-end" mt="md">
        <Skeleton height={36} width={90} />
      </Flex>
    </Box>
  );
}
